import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";


export const ChartInfoButton = ({ title, description }: { title: string; description: string }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        aria-label={`About ${title}`}
        onClick={e => e.stopPropagation()}
        className="shrink-0 rounded-full text-foreground/80 hover:text-primary hover:bg-primary/10 data-[state=open]:text-primary data-[state=open]:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 transition-colors p-1"
      >
        <Info className="h-5 w-5" strokeWidth={2.5} />
      </button>
    </PopoverTrigger>
    <PopoverContent
      align="start"
      className="w-64 text-sm leading-snug"
      style={{ backgroundColor: "hsl(var(--background))", color: "hsl(var(--foreground))" }}
      onClick={e => e.stopPropagation()}
    >
      {description}
    </PopoverContent>
  </Popover>
);
